// extracted by mini-css-extract-plugin
export default {"th":"aAM8m7"};